import React from 'react';
import { AlertTriangle, AlertCircle, Info } from 'lucide-react';
import { clsx } from 'clsx';

const STYLES = {
  red: {
    cls: 'bg-fire-100 text-fire-800 border-fire-300 dark:bg-fire-900/40 dark:text-fire-200 dark:border-fire-700',
    Icon: AlertTriangle,
  },
  yellow: {
    cls: 'bg-yellow-100 text-yellow-800 border-yellow-300 dark:bg-yellow-900/40 dark:text-yellow-200 dark:border-yellow-700',
    Icon: AlertCircle,
  },
  blue: {
    cls: 'bg-blue-100 text-blue-800 border-blue-300 dark:bg-blue-900/40 dark:text-blue-200 dark:border-blue-700',
    Icon: Info,
  },
};

const FlagBadge = ({ flag, compact = false }) => {
  const style = STYLES[flag.level] || STYLES.blue;
  const Icon = style.Icon;
  return (
    <span
      title={flag.message}
      className={clsx(
        'inline-flex items-center gap-1 border rounded-full font-medium',
        compact ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm',
        style.cls,
      )}
    >
      <Icon className={compact ? 'w-3 h-3' : 'w-4 h-4'} />
      {compact ? null : <span>{flag.message}</span>}
    </span>
  );
};

export default FlagBadge;
